var map = {
	"./en": [
		4282,
		1441
	],
	"./en.json": [
		4282,
		1441
	],
	"./es": [
		1225,
		8180
	],
	"./es.json": [
		1225,
		8180
	],
	"./zh-CN": [
		6959,
		7644
	],
	"./zh-CN.json": [
		6959,
		7644
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4748;
module.exports = webpackAsyncContext;